'use client'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from '@/shared/ui/use-toast'
import services from '../services'
import { CreateProject, createProjectMappers } from '../../lib'

const useHook = (
  params?: { refetchQueryKeys?: string[] } & {
    onSuccess?: (data: CreateProject) => void
  },
) => {
  const queryClient = useQueryClient()
  const mutationKey = [queryKeys((a, m, p) => a.project.createProject + m.post)]

  const mutaion = useMutation({
    mutationKey,
    mutationFn: async (payload: Partial<CreateProject>) => {
      const mappedPayload = createProjectMappers.mapCreateProjectToDto(payload)
      return apiResponseHandler(await services.create(mappedPayload))
    },
    onSuccess: (data) => {
      params?.onSuccess && params.onSuccess(createProjectMappers.mapCreateProject(data || {}))
      toast({
        title: 'Вы успешно создали проект!',
      })

      if (!params?.refetchQueryKeys) return null
      queryClient.refetchQueries({
        queryKey: params.refetchQueryKeys,
      })
    },
  })

  useEffect(() => {
    if (mutaion.isError) console.error(mutaion.error)
  }, [mutaion.error, mutaion.isError])

  const muationResult = {
    ...mutaion,
    data: createProjectMappers.mapCreateProject(mutaion.data || {}),
  }

  return muationResult
}

export default useHook
